import Cookies from 'js-cookie'

const TokenKey = 'ph2token'
const ApplicationId = 'ph2Id'

export function getToken() {
  return Cookies.get(TokenKey)
}

export function getApplicationId() {
  return Cookies.get(ApplicationId)
}


export function setToken(token) {
  return Cookies.set(TokenKey, token)
}
export function setApplicationId(id) {
  return Cookies.set(ApplicationId, id)
}

export function removeToken() {
  return Cookies.remove(TokenKey)
}

export function removeApplicationId() {
  return Cookies.remove(ApplicationId)
}



// WEBPACK FOOTER //
// ./src/utils/auth.js